import React from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Div from "@jumbo/shared/Div";
import { getAPIData, getAPIDataParams } from '../../../utils/apiFunction';
import menus from "../../../layouts/shared/sidebars/Sidebar/menus";
import { adalApiFetch } from '../../../../adalConfig';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import ControlledTextField from "../../../components/ControlledTextField";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { checkAccess } from '../../../utils/roleFunctions';
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import { textfieldDateFormat } from "../../../utils/dateFunctions";
import StringSelect from "../../../components/StringSelect";
import { userInfo } from '../../../../adalConfig';


const AddRole = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;   
    const [completed, setCompleted] = React.useState(props.completed);
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState(null);
    const [sections, setSections] = React.useState([{ label: "Other" }, ...menus]);
    const [section, setSection] = React.useState(null);
    const [name, setName] = React.useState(props.data ? props.data.name : null);
    const id = props.data ? props.data.id : '0';
    const Swal = useSwalWrapper();
    const requiredEditAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.EDIT };
    const [userId, setUserId] = React.useState(props.data ? props.data.userId : null);

    const validate = () => {
        var warningMessages = [];
        var errorMessages = [];

        if (name === null || name === '') {
            errorMessages.push('Name is required');
        }
        if (userId === null || userId === '') {
            errorMessages.push('User Id is required');
        }

        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    submit();
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
            });
        } else {
            submit();
        }
    }

    const submit = async () => {
        setLoading(true);
        setCompleted(true);
        var data = {
            Name: name,
            UserId: userId
        }
        var response = await adalApiFetch(fetch, uri + '/Roles/AddUpdate/' + id + '?' + new URLSearchParams({
            ...data
        }), {
            method: 'post',
        });
        var resp = await (response.json());

        setLoading(false);
        if (props.reload) {
            props.reload();
        }
    }

    return (
        <Box
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1, width: '24ch' },
            }}
            noValidate
            autoComplete="off"
        >
            <Div>
                <Grid container spacing={0} mb={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <ControlledTextField title="Name" state={name} setState={setName} disabled={completed} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <ControlledTextField title="User Id" state={userId} setState={setUserId} disabled={completed} />
                    </Grid>

                </Grid>

                <SubmitButtonDisplayer completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={validate} handleClose={props.handleClose} />

            </Div>
        </Box >
    );
};

export default AddRole;
